export function updateUrlParameter(uri: string, key: string, value: string) {
  if (typeof uri !== 'string') {
    console.error(`url ${uri} 格式非法`);
    return uri;
  }
  // remove the hash part before operating on the uri
  const i = uri.indexOf('#');
  const hash = i === -1 ? '' : uri.substr(i);
  uri = i === -1 ? uri : uri.substr(0, i);

  const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    uri = uri.replace(re, `$1${key}=${value}$2`);
  } else {
    uri = `${uri + separator + key}=${value}`;
  }
  return uri + hash;
}

export function removeSomeUrlParameter(uri: string, key: string) {
  if (typeof uri !== 'string') {
    console.error(`url ${uri} 格式非法`);
    return uri;
  }
  const i = uri.indexOf('#');
  const hash = i === -1 ? '' : uri.substr(i);

  uri = i === -1 ? uri : uri.substr(0, i);

  const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');

  if (uri.match(re)) {
    uri = uri.replace(re, '$1').replace(/[?&]$/, '');
  }

  return uri + hash;
}

export function removeUrlParameter(key: string) {
  return removeSomeUrlParameter(location.href, key);
}

export function getQueryString(name: string) {
  const _search = location.search;
  if (_search) {
    const reg = new RegExp(`(\\?|&)${name}=([^&]*)(&|$)`);
    const r = _search.match(reg);
    if (r != null) return unescape(r[2]);
    return '';
  }
  return '';
}

// 根据url判断是否是公司内网嵌套打开的docs @卫宁宁
export const inIframe = window.self !== window.top;

const isFromIntranetHandler = () => {
  const scene = getQueryString('scene');
  const intranetPlatform = ['team', 'data-track'].find(item => scene === `${item}-iframe`);
  return inIframe && intranetPlatform;
};

export const isFromIntranet = isFromIntranetHandler();

export const isSnapshot = !!~location.search.indexOf('snapshot=true');

// 通过 url 获取 docId、shortcutId
export function getDocIdFromUrl() {
  let pathRes = /^\/[sd]\/home\/(.*)$/g.exec(window.location.pathname);
  // 正常文档
  if (pathRes) {
    return {
      docId: pathRes[1]
    };
  }
  // 兼容知识库
  if (/\/k\/home\//.test(location.pathname)) {
    pathRes = /\/k\/home\/(.*)/.exec(window.location.pathname);
    if (pathRes) {
      const split = pathRes[1].split('/');
      return {
        shortcutId: split[0],
        docId: split[1]
      };
    }
  }

  return {};
}
